export const moduleCatalog = [
  { code: 'personas', label: 'Clientes / Proveedores', description: 'Personas, grupos y cuentas corrientes.' },
  { code: 'productos', label: 'Productos', description: 'Productos, categorías, unidades y listas de precios.' },
  { code: 'ventas', label: 'Ventas', description: 'Presupuestos, ventas, remitos y recibos.' },
  { code: 'compras', label: 'Compras', description: 'Compras y órdenes de pago.' },
  { code: 'liquido_producto', label: 'Líquido Producto', description: 'Liquidaciones, lugares e ítems a facturar.' },
  { code: 'movimientos', label: 'Movimientos', description: 'Tipos y agrupaciones de movimientos.' },
  { code: 'arca', label: 'ARCA', description: 'Facturación electrónica y parámetros fiscales.' },
  { code: 'contabilidad', label: 'IVA y Contabilidad', description: 'IVA Digital y aperturas impositivas.' },
  { code: 'reportes', label: 'Reportes', description: 'Reportes comerciales y operativos.' }
] as const

export type ModuleCode = typeof moduleCatalog[number]['code']
export type EnabledModules = Partial<Record<ModuleCode, boolean>>

export const defaultEnabledModules: Record<ModuleCode, boolean> = {
  personas: true,
  productos: true,
  ventas: true,
  compras: true,
  liquido_producto: true,
  movimientos: true,
  arca: true,
  contabilidad: false,
  reportes: true
}

export function normalizeEnabledModules (raw?: EnabledModules | null): Record<ModuleCode, boolean> {
  const normalized = Object.fromEntries(
    moduleCatalog.map(({ code }) => [code, raw?.[code] ?? defaultEnabledModules[code]])
  ) as Record<ModuleCode, boolean>

  if (normalized.ventas) {
    normalized.personas = true
    normalized.productos = true
  }
  if (normalized.compras || normalized.liquido_producto || normalized.movimientos) {
    normalized.personas = true
  }
  if (normalized.contabilidad) normalized.arca = true
  return normalized
}

const routeModules: Array<[RegExp, ModuleCode]> = [
  [/^\/iva-digital(?:\/|$)/, 'contabilidad'],
  [/^\/liquidos-producto(?:\/|$)/, 'liquido_producto'],
  [/^\/ordenes-pago(?:\/|$)/, 'compras'],
  [/^\/compras(?:\/|$)/, 'compras'],
  [/^\/clientes\/[^/]+\/nueva-orden-pago(?:\/|$)/, 'compras'],
  [/^\/clientes\/[^/]+\/nuevo-recibo(?:\/|$)/, 'ventas'],
  [/^\/reporte-recibos(?:\/|$)/, 'reportes'],
  [/^\/(?:ventas|nueva-venta|presupuestos|remitos|recibos)(?:\/|$)/, 'ventas'],
  [/^\/(?:productos|categorias|grupos_productos|unidades|listas-precios)(?:\/|$)/, 'productos'],
  [/^\/(?:movimientostipo|movimientogrupos)(?:\/|$)/, 'movimientos'],
  [/^\/(?:puntos-venta|percepciones-retenciones|iva2002)(?:\/|$)/, 'arca'],
  [/^\/perfil\/(?:ayuda-afip|certificados-afip)(?:\/|$)/, 'arca'],
  [/^\/(?:clientes|proveedores|grupos|cuenta-corriente)(?:\/|$)/, 'personas']
]

export function requiredModuleForPath (path: string): ModuleCode | null {
  return routeModules.find(([pattern]) => pattern.test(path))?.[1] || null
}
